export default {
  custom: {
    linkedReference: '联动引用',
    boot: '开机',
    shutDown: '关机',
    notLinked: '未联动',
    maxLinkedTip: '最多只能有 2 个{type}联动，已自动恢复为未联动',

    bar_Power: '电源控制',
    bar_Video: '视频输入切换',
    bar_Vol: '音量调节',
    bar_Audio: '音频切换',
    bar_Serial: '串口控制',
    bar_Air: '空调控制',
    bar_Projection: '幕布控制',
    bar_Remote: '智能遥控',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: '必须要同时选择三个图片',
    notSelected: '未选择',
    choose: '选择',
    disable: '禁用',
    longPressAndDrag: '长按并拖动调整列表顺序',
    isrestoreDefault: '是否要恢复到默认状态',
    saveAndSync: '保存并同步',
    restoreDefault: '恢复默认',
    limitPNG: '上传图片只能是PNG格式!',
    limit1M: '上传图片大小不能超过 1MB！',
    selectTheImage: '选择图片',
    textsuggestions: '建议使用尺寸48*48 px，1M以内的白色png图标',
    iconLibrary: '图标库',
    panelNavigationBarCustomization: '面板导航栏',
    logoCustomization: '面板Logo',
  },
  outlook: {
    privacy: '绑定微软组织隐私协议',
    privacyContent: "同意",
    AuthVerify4004One: '绑定失败：该微软租户（ID:',
    AuthVerify4004Two: "）已被 [",
    AuthVerify4004Three: "]组织占用,如需更换绑定，请先解绑原有组织，或使用不同的微软租户。",
    theMicrosoftTenantIsOccupied: '该微软租户已被占用',
    Viewtutorial: '查看绑定教程',
    checktenantID: '请检查你的租户ID、应用程序ID、应用密钥是否正确。',
    ErrorCode: '错误码：',
    AuthorizationFailed: '授权失败',
    Accesshasbeengranted: '已获得Microsoft Graph API访问权限',
    successfullyauthorizedDescribe: '所需权限已成功授权，会议室数据将自动同步，请关闭该页面',
    Close: '关闭',
    resourceID: '资源ID',
    dialogTips: '提示',
    theAuthorizationIsDeleted: '删除授权成功',
    theBindingIsSuccessful: '绑定成功',
    theUnbindingIsSuccessful: '解绑成功',
    unbindingFailed: '解绑失败',
    theUnbindingHasBeenUnbound: '已取消解绑',
    continueUnbinding: '解绑后将不再同步 Outlook 日程，并清除未开始的日程。是否继续解绑？',
    areYouSureAboutUnbinding: '解绑后将清除所有来自 Outlook 且未开始的日程，并停止日程同步。解绑后不可恢复，请确认是否继续？',
    UnbindNotSynchronized: '绑定成功后，系统会自动从Outlook同步该会议室的新增日程（不同步历史会议）',
    unbinding: '解绑',
    bindUnableToSelect: '已绑定，无法选择',
    permissAThird: '请授权绑定第三方资源',
    resourceMailbox: '资源邮箱：',
    PleasecheckID: '授权失败！请检查你的租户ID、应用程序ID、应用密钥是否正确。',
    Waitingforauthorization: '正在等待授权完成...',
    Pleasecompletetheauthorization: '已打开Microsoft 365授权登录页面，请登录组织管理员账号并完成授权',
    pleaseEnterTheTenantID: '请输入租户ID',
    pleaseEnterTheClientID: '请输入应用ID',
    pleaseEnterTheClientSecret: '请输入应用密钥',
    Authorizationcompleted: '已完成授权',
    Authorizelogin: '授权登录Microsoft 365',
    ApplicationID: '租户ID',
    ClientID: '应用ID',
    ClientSecret: '应用密钥',
    registTipOne: '请根据',
    registTipTwo: '绑定教程',
    registTipThree: '完成 Azure 应用注册与权限配置后，再填写以下信息',
    MicrosoftDescribe: '通过绑定 Microsoft 365，可实现 Outlook/Teams 预约会议室时自动同步至 Qnex 系统与会议门牌。',
    Addcalendarservice: '日历同步设置',
    Lasttimesynchronization: '上次同步时间',
    Allocated: '已分配',
    Total: '总计',
    Conferenceroomresources: '会议室资源',
    Bindingtime: '绑定时间',
    Bindtheplatform: '绑定平台',
    Synchronousstate: '同步状态',
    Organizationname: '组织名称',
    Bindthirdpartycalendar: '绑定第三方日历',
    TenantIDTip: 'Azure AD 中租户的唯一标识',
    ApplicationIDTip: '在 Azure 中注册的应用 ID。',
    ApplicationSecretTip: '在 Azure 应用中生成的客户端密码，用于身份验证。'
  },
  meetingManager: {
    IdleDisplayTextTable: '空闲显示文本',
    IdleDisplayText: '空闲显示文本：',
    IdleDisplayTextContent: '会议室空闲时显示的文本（默认：“空闲”）',

    duplicateMeetingRoomName: '会议室名称重复',
    duplicateMeetingRoomNameContent: '已存在名为“{duplicate_content}”的会议室，请重新输入。',
    NumberOfRoomPanels: '会议室面板数量',
    Thecurrentterminalhasbeenboundtoanotherorganization: '当前终端已经在其他组织绑定',
    theTerminalNameOrIDIsDuplicated: '面板名称或id重复',
    theRoomNameOrIDIsDuplicated: '会议室名称或地点重复',
    AddMeetingRoom: '新增会议室',
    EditMeetingRoom: '编辑会议室',
    MeetingRoomName: '会议室名称：',
    Location: '地点：',
    ReservationApproval: '预约审批：',
    ApprovalListYes: '是',
    ApprovalListNo: '否',
    Capacity: '容纳⼈数：',
    RoomStatus: '会议室状态：',
    BindRoomDisplay: '面板绑定：',
    meeting_btnAdd: '新增',
    meeting_btnEdit: '编辑',
    meeting_btnBind: '绑定设备',
    meeting_btnDel: '删除',
    meeting_tableRoomName: '会议室名称',
    meeting_tableRoomPlace: '地点',
    meeting_tableAppointmentApproval: '预约审批',
    meeting_tableCapacityForPeople: '容纳人数',
    meeting_tableMeetingRoomStatus: '会议室状态',
    meeting_tableAvaliable: '可用',
    meeting_tableOutofService: '停用',
    meeting_tableDoorBind: '门牌绑定',
    meeting_tableBindNPS: '绑定NPS',
    meeting_tableActions: '操作',
    door_theNameOfTheTerminal: '面板名称：',
    door_deviceID: '面板ID：',
    door_Wallpaper: '壁纸：',
    door_Wallpaper_text: '推荐图⽚尺⼨:尺⼨ 1280x800，PNG 格式',
    door_bindAMeetingRoom: '绑定会议室：',
    door_table_name: '面板名称',
    door_table_deviceID: '面板ID',
    door_table_status: '状态',
    door_table_ipAddress: 'IP地址',
    door_table_bindAMeetingRoom: '绑定会议室',
    door_btnAdd: '新增',
    door_btnBatchAdd: '批量新增',
    door_btnEdit: '编辑',
    door_btnBatchEdit: '批量编辑',
  },
  InputSourcesLinkage: {
    configurationAddTitle: '添加配置',
    configurationEditTitle: '编辑配置',
    dialogConfigName: '配置名称',
    selectNMPAndNDP: 'NMP/NDP选择',
    powerControl: '电源控制',
    executeCommand: '执行命令',
    tableConfigName: '配置名称',
    selectConfig: '请选中配置',
  },
  NPS: {
    Relay: '继电器',
    RelaySettings: '继电器设置',
    DevicePower: '设备电源控制',
    DeviceElevation: '升降控制',
    LinageWithNPSPower: '与NPS电源的联动',
    PresentationSwitch: '演示切换',
    Duplicate: '复制',
    LinkagewithNPSPowe: '与NPS电源联动',
  },
  PTZ: {
    powerSupplyON: '电源ON',
    powerSupplyOFF: '电源OFF',
    LEFT: '左移',
    RIGHT: '右移',
    UP: '上移',
    DOWN: '下移',
    HOME: 'Home键',
    ENLARGE: '放大',
    REDUCTION: '缩小',
    StopMovement: '停止移动',
    STOP: '停止缩放',
    FOCUS: '自动对焦',
    SET_PRESETS0: '设置预设位0',
    SET_PRESETS1: '设置预设位1',
    SET_PRESETS2: '设置预设位2',
    SET_PRESETS3: '设置预设位3',
    SET_PRESETS4: '设置预设位4',
    SET_PRESETS5: '设置预设位5',
    SET_PRESETS6: '设置预设位6',
    SET_PRESETS7: '设置预设位7',
    SET_PRESETS8: '设置预设位8',
    SET_PRESETS9: '设置预设位9',

    USE_PRESETS0: '调用预设位0',
    USE_PRESETS1: '调用预设位1',
    USE_PRESETS2: '调用预设位2',
    USE_PRESETS3: '调用预设位3',
    USE_PRESETS4: '调用预设位4',
    USE_PRESETS5: '调用预设位5',
    USE_PRESETS6: '调用预设位6',
    USE_PRESETS7: '调用预设位7',
    USE_PRESETS8: '调用预设位8',
    USE_PRESETS9: '调用预设位9',

  },
  schedule: {
    startLinkPowerStart: '电源（CBXs）',
    startLinkPowerStop: '电源（CBXs）',
    dehumidification: '除湿',
    airSupply: '送风',
    masterControl: '主控制：',
    powerSupply: '电源',
    RecordingControl: '录播控制',
    RecordingControlSystem: '录播系统',
    LiquidCrystal: '液晶',
    projector: '投影仪',
    othertype: '其他',
    lockScreen: '锁屏',
    childLock: '童锁',
    energySaving: '节能',
    signalSourceSwitching: '信号源切换',
    other: '其他功能：',
    otherFunction: '功能',
    send: '发送',
    ON: '开',
    OFF: '关',
    btnAddSchedule: '恢复清单',
    EditSchedulelist: '修改任务清单',
    AddSchedulelist: '新建任务清单',
    RestoreSchedulelist: '恢复任务清单',
    btnCancel: '取消',
    btnNewList: '新建清单',
    ListName: '任务清单名称',
    Cannotquit: '强制广播',
    NOCannotquit: '非强制广播',
    ListValidityPeriod: '任务清单有效期',
    ListDescription: '任务清单描述',
    currentSchedule: '现行日程清单',
    historySchedule: '历史日程清单',
    selectTime: '时间:',
    taskType: '任务类型:',
    selectBroadcasting: '广播控制',
    selectDeviveControl: '设备控制',
    newSchedule: '新建任务',
    newChecklist: '新建清单',
    titleStatus: '状态',
    titleType: '类型',
    titleStartTime: '开始时间',
    titleEndTime: '结束时间',
    titleRepeat: '重复方式',
    titleName: '任务名称',
    titleAction: '操作',
    tableEnabled: '启用',
    tablePaused: '停止',
    tableEdit: '修改',
    tableDelete: '删除',
    tableVolumeEdit: '广播音量',
    tableBroadcastTitle: '广播标题',
    tableBroadcastContent: '广播内容',
    tableBroadcastList: '广播列表',
    tableBroadcast: '广播方式',
    btnRemoveCompletely: 'Remove completely',
    btnEnabled: '启用',
    btnPaused: '停止',
    btnDelete: '删除',
    repeat0: '周一',
    repeat1: '周二',
    repeat2: '周三',
    repeat3: '周四',
    repeat4: '周五',
    repeat5: '周六',
    repeat6: '周日',
    dialogTitleAdd: '新建设备控制日程',
    dialogTitleEdit: '修改设备控制日程',
    newBroadcastingSchedule: '新建广播任务日程',
    editBroadcastingSchedule: '修改广播任务日程',
    chooseDevice: '选择目标设备',
    timeSetting: '时间设置',
    controlBroadcasting: '广播选项',
    controlOption: '控制选项',
    scheduleName: '任务名称:',
    destination: '目标设备:',
    timeTilte: '开始时间:',
    repeatTitle: '重复选项:',
    dialogRepeat0: '周一',
    dialogRepeat1: '周二',
    dialogRepeat2: '周三',
    dialogRepeat3: '周四',
    dialogRepeat4: '周五',
    dialogRepeat5: '周六',
    dialogRepeat6: '周日',
    dialogOnceType: '一次',
    dialogRepeatType: '多次',
    mainPower: '主电源',
    powerControl: '电源控制',
    tableDisplayInputSwitch: '音视频输入切换',
    tableAirConditioning: '空调',
    tableProjectionScreen: '投影幕布',
    tableElectronicLock: '电子锁',
    interactiveFlatPanel: 'Interactive Flat Panel',
    displayInputSwitch: '音视频输入切换：',
    speakerVolume: '音箱音量',
    MICVolume: '麦克风音量',
    ProjectionScreen: '投影幕布：',
    ElectronicLock: '电子锁：',
    AirConditioning: '空调',
    AirConditioningPower: '电源:',
    AirConditioningModel: '模式:',
    AirConditioningTEMP: '温度:',
    AirConditioningFanSpeed: '风速：',
    OPEN: '开',
    CLOSE: '关',
    UP: '升',
    DOWN: '降',
    PowerOFF: '关',
    PowerON: '开',
    ModelAuto: '自动',
    ModelCool: '制冷',
    ModelHeat: '制热',
    ModelAir: '扫风',
    TEMPLow: '低',
    TEMPMiddle: '中',
    TEMPHigh: '高',
    btnSave: '保存',
    btnNext: '下一步',
    StartTime: '开始时间',
    StopTime: '结束时间',
    Mandatory: '是否强制广播：',
    Video: '音视频广播',
    Notification: '文字广播',
    btnFile: '选择媒体文件',
    LastingTime: 'Lasting Time',
    textTitle: '标题:',
    textContent: '内容:',
    textTitleLetters: '60字以内',
    textContentLetters: '320字以内',
    CannotquitYES: '是',
    CannotquitNo: '否',
    YES: 'YES',
    No: 'No',
    delTitleContent: '删除任务清单？',
    delTitleListContent: '删除的任务清单将移动到历史日程清单中，可在历史日程清单中恢复',
    deleListTitle: '删除任务清单？',
    delTitleListContent1: '删除任务清单将导致与其相关的任务都被清除，请确认。',
    deleListTitle1: '确定删除该任务清单？',
    delTitle: '确定删除?',
    btnConfirm: '确认',
    coxAll: '所有任务',
    coxBroadcasting: '广播控制',
    coxDeviveControl: '设备控制',
    rdMandatory: '强制',
    noRdMandatory: '非强制',
    startDate: '开始日期',
    endedDate: '结束日期',
    or: '-',
    broadcastingType: '广播类型',
    ChooseTime: '选择时间',
    ChooseDate: '选择日期',
    newScheduleList: '新建任务清单',
    editScheduleList: '修改任务清单',
    listName: '任务清单名称',
    listValidityPeriod: '任务清单有效期',
    listDescription: '任务清单描述',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    restoreSuccess: '日程清单已恢复',
    restoreError: '日程清单恢复失败',
    restoreTitleContent: '该时间与清单内任务时间冲突，请重新选择',
    Enabled: '启用',
    Paused: '停止',
    Title: '标题:',
    Content: '内容:',
    errorScheduleNameRequired: '任务名称不能为空',
    errorDeviceRequired: '请选择目标设备',
    deleTitle: '确定删除该任务？',
    loopList: '列表循环',
    errorPleaseDateRange: '请选择日期区间',
    'addError_2009': '清单名称重复',
    conflicts: '所要创建的任务与以下任务时间冲突：',
    Pleaseagain: '请重新输入',
    errorScheduleName: '清单名',
    errorListName: '清单名',
    'today': '今天',
    'yesterday': '昨天',
    'thisWeek': '本周',
    'lastWeek': '上周',
    'lastMonth': '上月',
    'thisMonth': '本月',
    'times': '次数',
    TimeConflicts: '时间冲突',
    'editError_2006': '查询不到设备 ',
    'editError_2010': '任务名称重复',
    ListTimeExpired: '清单时间已过期，请重新选择',
    TimeExpired: '时间已过期',
    ControlOption: '控制选项未填',
    Pleaseleastone: '请至少选择选择控制选项内容',
    Enter: '请输入内容',
    TitleFilled: '请填写标题',
    ContentFilled: '请填写内容',
    PleaseMediaFile: '请选择文件',
    PleaseSchedule: '请选择要操作任务',
    delTitleScheduleContent: '删除的任务无法恢复',
    deleTitleSchedule: '确定删除任务吗？',
    deleteScheduleTitle: '请选择要删除的任务',
    PleaseFillColumn: '请填写清单名称',
    PleaseDate: '请选择日期',
    Previous: '上一步',
    RemoteControl: '智能遥控',
    taskhasexpired: '此任务已过期，请联系创建人更新时间',
    execute: '执行',
    broadcastingList: '播放列表',
    volumeSuccess: '音量设置成功',
    volumeFailed: '音量设置失败',
  },
  Automation: {
    nameDuplicate: '自动任务名称重复',
    Automation: '自动化控制',
    if: '如果:',
    ifContent: '‘如果’部分允许您基于传感器数据设置条件。选择传感器并指定条件，例如\'温度 > 26°C\'。',
    then: '则执⾏:',
    thenContent: '‘则执⾏’部分让您选择设备并为它们定义操作。选择设备如NMP1、NMP2并为空调指定操作，例如\'开机+制冷\'。',
    btnDelete: '删除',
    Add: '新增',
    taskName: '任务名称',
    dialogTaskName: '任务名称:',
    Statue: '状态',
    DevicesApplied: '应用设备',
    Operation: '操作',
    AirConditioningPower: '电源:',
    AirConditioningModel: '模式:',
    AirConditioningTEMP: '温度:',
    AirConditioningFanSpeed: '风速：',
    bold: '扫风：',
    selectTask: '请选中任务',
    autoTaskAdd: '新增自动化控制任务',
    autoTaskEdit: '编辑自动化控制任务',
    Destination: '目标设备',
    selectConditions: '请指定您要执行的操作',
    selectDestination: '请选择⽬标 NMP(s) 设备，然后指定您要执行的操作',
    AirConditioningTEMP: '温度',
    AirConditioningHumidness: '湿度',
    noData: '尚未添加任何任务，请点击“新增”按钮进⾏添加',
  },
  rs232Translation: {
    reliveBinding: '解除绑定',
    RELIVEBINDING: '解除绑定',
    ACTO: '雅图',
    AMENA: 'AMENA',
    APPOTRONICS: '光峰',
    APTI: 'APTI',
    ASEE: '澳视投影机',
    ASK: 'ASK',
    AUCMA: '澳柯玛',
    AUX: '奥克斯',
    BARCO: '巴可',
    BENQ: '明基',
    BOERKA: '波尔卡',
    BOXLIGHT: '宝视来',
    Canon: '佳能',
    CARRIER: '开利',
    CHANGHONG: '长虹',
    CHIGO: '志高',
    CHRISTIE: '科视',
    Chunlan: '春兰',
    COSTAR: '中光学',
    CROWN: '皇冠',
    CX: '晨星',
    DAEWOO: '大宇',
    DAIKIN: '大金',
    DIGITEL: 'DP',
    DONGBAO: '东宝',
    EIKI: '爱其',
    electra: '凉宇',
    Electrolux: '伊莱克斯',
    EPSON: '爱普生',
    FEILU: '飞鹿',
    FOUNDER: '方正',
    Frestec: '新飞',
    Fujitsu: '富士通',
    Galanz: '格兰仕',
    GREE: '格力',
    Haier: '海尔',
    Hisense: '海信',
    HITACHI: '日立',
    HP: '惠普',
    HUIFENG: '汇丰',
    InFocus: '富可视',
    IQ: 'IQ',
    JVC: '胜利',
    KODAK: '可达',
    LANGER: '朗歌',
    LENOVO: '联想',
    LG: 'LG',
    LITTLESWAN: '小天鹅',
    LUMENS: '捷扬光电',
    McQuay: '麦克维尔',
    Microtek: '中晶',
    Mitsubishi: '三菱',
    NANFENG: '南风',
    NEC: 'NEC',
    OPTOMA: '奥图码',
    PALOROID: 'Paloroid',
    panisonic: '松下',
    PHILIP: '飞利浦',
    PJD: '优派',
    PLUS: '普乐士',
    POLAROID: '宝丽来',
    PROPIX: '派克斯',
    PROXIMA: 'Proxima',
    RAYBO: '蓝波',
    ROWA: '乐华',
    Samsung: '三星',
    SANYO: '三洋',
    SAST: '先科',
    SEEMILE: '视美乐',
    SHARP: '夏普',
    shengfeng: '胜风',
    Shinco: '新科',
    shuanglu: '双鹿',
    Sony: '索尼',
    SOVA: '索华',
  },
  VcbEdit: {
    VcbNameNoNull: 'CBX名称不能为空',
    BrandNoNull: '品牌不能为空',
    ModelNoNull: '型号不能为空',
    AcNoNull: '空调不能为空',
    RcNoNull: '智能遥控不能为空',
  },
  route: {
    customize: '自定义',
    InputSourcesLinkage: '输入源切换联动',
    Automation: '自动化任务',
    dashboard: 'Dashboard',
    i18n: 'I18n',
    organizationMge: '组织管理',
    userMge: '用户管理',
    authorityMge: '权限管理',
    roleMge: '角色权限管理',
    equipmentMge: '设备管理',
    workstationMge: '媒体工作站管理',
    cloudDiskMge: '存储管理',
    operationLog: '操作日志',
    setting: '系统设置',
    resourceMge: '资源管理',
    storageMge: '存储空间管理',
    interfaceRename: '接口重命名',
    processorManager: '设备管理',
    projectorCode: '串口码管理',
    projectorCodeSetting: '串口码设置',
    RepairLog: '报修日志',
    remoteControl: '智能遥控码管理',
    acCode: '空调码管理',
    cardMge: '卡管理',
    cardLog: '卡管理日志',
    cardManager: '卡管理',
    meetingManager: '会议管理',
    meetingRoomManager: '会议室管理',
    meetingDoorManager: '会议室面板管理'
  },
  navbar: {
    logOut: ' 退出登录',
    dashboard: '管理后台',
    screenfull: '全屏',
    language: '选择语言',
    userConsole: 'Q-NEX工作台',
    BackTianwa: '返回天蛙云',
  },
  feedback: {
    Feedback: '意见反馈',
    email: '请留下邮箱以便我们快速反馈',
    content: '欢迎留言帮助我们更好地改进产品，感谢您的意见和建议。',
    submit: '提交',
    emailNoEmpty: '邮箱不能为空',
    emailTrueRule: '请输入正确格式的邮箱',
    contentNoEmpty: '内容不能为空',
    feedbackSuccess: '反馈成功',
    feedbackFailed: '反馈失败',
    emailNoChinese: '邮箱不能有汉字',
    emailLength: '长度在 5 到 100 个字符',
    GroupNameLength: '长度在 1 到 20 个字符',
    emailSpecialString: '此输入框不能包含特殊字符串'
  },
  login: {
    title: '欢迎回来',
    logIn: '登录',
    username: '用户名',
    password: '密码',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    // userNameTitle:['请输入用户名'],
    // passWordTitle:['请输入密码'],
    // verCodeTitle:['请输入验证码'],
    placeholder: ["用户名", "密码", "验证码"],
    userNameTitle: '用户名不符合要!',
    forget: '忘记密码?',
    loginTitle0: '登录成功!',
    loginTitle1000: '用户名或密码错误!',
    loginTitle1001: '用户名、密码不能为空!',
    loginTitle1002: '验收码不能为空!',
    loginTitle1003: '用户名状态非法，登录失败!',
    loginTitle1004: '验证码错误!',
    loginTitle1005: '未登录，请先登录!',
    loginTitleUserName: '用户名不能为空!',
    loginTitlePwd: '密码不能为空!',
    loginTitleVercode: '验证码不能为空!',

    errorLogin: '用户权限不足不能登录！',
    titleLoginNameFormat: '账号格式只能输入字母和数字'
  },
  organizationMge: {
    CanTDragTop: '无法拖拽至根目录上层',

    prefixCannotBeEmpty: '超级管理员账号前缀不能为空',
    enterEnglishLetters: '超级管理员账号前缀只能输入英文字母和数字',
    dateNotSelected: '流媒体服务有效期开始日期未选择',

    btnAddChild: '添加下级',
    btnAddSibling: '添加同级',
    title: '提示:',
    againTitle: '请再次确认:',
    schoolName: '名称:',
    type: '类型：',
    sort: '排序:',
    equipmentNum: '设备数量:',
    accountPrefix: '超级管理员账号:',
    organization: '代理机构',
    terminalMechanism: '终端机构',
    organizationNum: '终端机构数量:',
    adminName: '超级管理员账号:',
    adminPwd: '超级管理员密码:',
    realName: '真实姓名:',
    serialNum: '序列号:',
    edit: '修改',
    add: '添加',
    del: '删除',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '修改成功！',
    editError: '修改失败!',
    delSuccess: '删除成功！',
    delWarn: '组织机构下存在设备，不允许删除',
    delError: '删除失败!',
    // copySuccess:'复制成功',
    copyError: '该浏览器不支持自动复制',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    Trial: '试用',
    TrialWorkstation: '您当前为流媒体服务试用状态。最多只可向三台终端设备发送广播命令。',
    Normal: '正常',
    NormalWorkstation: '您的流媒体服务的有效期为',
    to: '至',
    Advent: '临期',
    AdventWorkstationOne: '您的流媒体服务即将于',
    AdventWorkstationTwo: '到期，请及时联系您的代理商续费以免影响正常使用。',
    Expired: '逾期',
    ExpiredWorkstation: '您的流媒体服务已到期，请联系您的代理商及时续费。',
    admin: '超级管理员：',
    serviceState: '流媒体服务状态：',
    serviceStateLIST: '流媒体服务状态',
    ValidityPeriod: '到期时间：',
    ValidityPeriodLIST: '到期时间',
    Trial: '试用',
    Permanent: '永久使用',
    AnnualBilling: '按年计费',
    mediaValidityPeriod: '流媒体服务有效期：',
    contactInformation: '联系方式（用于流媒体服务续费弹窗展示）',
    company: '公司：',
    email: '邮箱：',
    phone: '电话：',
    StartDate: '开始日期',
    EndDate: '结束日期',
    To: '至',
    TerminalName: '终端名称',
    Competence: '超级管理员',
    operate: '操作',
    statusFilter: '状态筛选',
    disableStreaming: '确定要停用流媒体服务吗？',
    enableStreaming: '确定要启用流媒体服务吗？',
    disableStreamingContent: '停用后该组织将无法使用广播和直播的相关功能。',
    enableStreamingContent: '已过期的组织请注意修改有效期限。',
    search: '输入组织名称',
    optionsYearZero: '请选择',
    optionsYearOne: '一年',
    optionsYearTwo: '两年',
    optionsYearThree: '三年',

    dialogName: '名称:',
    detTitle: '删除该组织将导致它的下级组织及相关数据被删除，请确认.',
    groupDelTitle: '确认删除？',
    delTitle: '确认删除?',
    delTitleContent: '删除该内容将导致相关数据被删除，请确认。',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    copySuccess: '内容已复制到剪贴板.',
    error1200: '存在同名的组织机构',
    error1201: '存在同名的终端机构名称或代理机构名称',
    error1202: '超出最大可连接设备数量',
    error1203: '存在同名的用户',
    error1204: '在同一级上存在同名的组织',
    error1210: '请输入管理员密码',
    warningGroup: '请先选择一个组织！',
    warningTerminal: '终端机构不能再创建机构！',
    account: '组织名重复',
    titleOrganization: '注意：账号前缀是在组织层级定义的。该组织下的所有用户账号都将共享相同的前缀。',
    // titleShooleFormat:'账号格式只能输入字母和数字',

  },
  userMge: {
    nickName: '昵称',
    contentWithBrand: '输入品牌或者型号',
    contentwithIp: '输入设备名称或者IP地址检索',
    btnAdd: '新用户',
    btnDelete: '删除',
    btnDownload: '下载模板',
    btnImport: '批量导入',
    btnExport: '下载',
    btnDisable: '禁用用户',
    btnEnable: '启用用户',
    accountType: '按角色筛选',
    organizationName: '按组织架构筛选',
    content: '搜索',

    // manualImport:'手动录入',
    // batchImport: '批量录入',
    // export:'导出',
    // templateDownload:'模板下载',
    // btnEdit:'修改',
    // resetPwd:'重置密码',
    // restart:'启用',
    // disable:'停用',
    // obsolete:'作废',
    systemAccount: '用户ID',
    idCardNumber: '工号',
    customizeAccount: '账号（自定义）',
    userName: '姓名',
    licenseNum: '证件号',
    phone: '电话',
    email: '邮箱',
    // sex:'性别',
    role: '角色',
    status: '状态',
    // associate:'关联的组织机构',
    affiliatedOrganization: '组织',
    // search:'搜索',
    roleTypeList1: "普通用户",
    roleTypeList2: "学生",
    roleTypeList3: "家长",
    roleTypeList101: "机构管理员",
    roleTypeList102: "超级管理员",
    roleTypeList301: "超级管理员",
    userStatus1: "使用中",
    userStatus2: "屏蔽",
    userStatus3: "删除",
    // roleTypeList:{1:"老师",2:"学生",3:"家长",101:"机构管理员",102:"终端机构管理",301:"超级管理员"},
    operate: '操作',
    dialogName: "昵称:",
    dialogUserName: "用户ID:",
    dialogUserNameDefined: "登录名:",
    dialogPassword: "密码:",
    dialogID: "工号:",
    dialogRole: "角色:",
    dialogEmail: "邮箱:",
    dialogPhone: "电话:",
    dialogGroup: "组织:",
    // edit:'Edit',
    // add:'Add',
    addUser: '新用户',
    editUser: '编辑用户',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '修改成功！',
    editError: '修改失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    tableDel: '删除',
    tableEdit: '编辑',
    selectRoles: '选择角色',
    delTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗?',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    titleRealNameRq: '此项必填',
    titleRealNameFormat: '账号格式只能输入字母和数字',
    checkPasswordTitleTwo: '请设置 6 位及以上的密码，需包含字母和数字，可使用特殊符号（不限制）',
    checkPasswordTitle: '密码至少6位且不能为纯数字',
    titlePhoneFormat: '电话只能填写数字和()+，-',
    phoneFilled: '电话为必填项',
    titleEmaileFormat: '邮箱格式填写错误.',
    emaileFilled: '邮箱为必填项.',
    titlUserNameDefinedNub: '用户名不可超过30个字符',
    titlRealNameNub: '姓名不可超过30个字符',
    titlRealNameField: '姓名为必填项',
    thisPasswordField: '密码为必填项',
    titlPassWordNub: '密码需在6~30个字符之间',
    selectRecord: '请选择激活码记录！',
    enableStatus: '启用',
    stopStatus: '停止',
    enableContent: '是否启用？',
    stopContent: '是否要停止？',
    error1400: '登录名已存在，请重试',
    error1401: '用户ID 已经存在，操作失败!',
    error1402: '学校不存在，导入失败！',
    error1403: '数据存在错误',
    error1404: '权限不足',
    selUser: '请选择用户！',
    error1900: '访问的参数为空',
    error1610: '请使用超级管理员角色，进行相关操作',
    error1405: '获取角色失败',
    error1406: '导入的用户信息数据格式不正确',
    error1407: '邮箱 已经存在，操作失败',
    error1408: '电话 已经存在，操作失败',
    errorOrgIdList: '组织机构不能为空！',
    Bindsucceeded: "关联成功",
    Bindfailed: '关联失败',
    tableuserName: '登录名',
    titleDevice: '设备',
    bindDevice: '绑定设备',
    Bindcontrollable: '是否现在关联可控设备？',

  },
  devicesMge: {
    mustChooseOne: '开关机联动，勾选智能遥控时,至少要选择一个控制命令',
    customName: '自定义名称',
    testAcCode: '测试空调控制码',
    Online: '在线',
    Offline: '离线',
    unBindConfirm: '确认解除绑定串口',
    unBindConfirm485: '确认解除绑定RS485',
    notYetBoundRS232: '该设备尚未绑定串口码，你可以前往设备管理 > 串口码管理进行添加',
    RsFollowingFunctions: '通过串口码可以实现如下功能：',
    Unbind: '解除绑定',
    Limit255: '文件名不允许超过255个字符',
    clear: '清空',
    equipName: '设备名',
    equipType: '类型',
    selectField: '请选择文件',
    dialogTip: '*右侧输入框为空时，默认显示左侧内容',
    dialogTipSingle: '*单个设备未命名时，跟随"ALL"的命名',
    cantDelTemplateOne: '',
    cantDelTemplateTwo: '设备【{deviceName}】下的CBX为模板，确认要删除吗？',
    templateTitle: '确认替换模板',
    templateContentOne: '已将设备名称"',
    templateContentTwo: '"设为CBX的通用模板，确认要将当前设备设为模板吗？',
    vcbNoTemplateNoSave: '没有设置模板，无法保存',
    vcbAcControl: '空调',
    vcbRemoteControl: '智能遥控',
    vcbPOWERControl: '电源控制',
    vcbRS232Control: '串口控制',
    vcbIRControl: '红外控制',
    vcbSetting: '的CBX设置',
    editVcb: '编辑CBX',
    vcbName: 'CBX名称',
    iot: 'CBX控制',
    saveAsTemplate: '设为模板',
    saveAsTemplatereplenish: '选择多个设备在控制中心中使用该模板',
    Upload: '上传文件',
    Select: '选取文件',
    InputDeviceID: '导入设备码',
    editNameTips: '* 右侧输入框为空时，默认显示左侧内容',
    "_RS232A": '接口一',
    "_RS232B": '接口二',
    institutionDirectory: '机构目录',
    projectionScreenLinkageSetting: "投影幕布联动设置",
    screenLiftingLinkageDisplaySwitch: "幕布升降联动Display开关:",
    stopLinkage: "停用联动（幕布需单独控制)",
    Enable: "启用联动（开启降下，关闭升起)",
    btnAddDevice: '添加设备',
    btnImportDevice: '批量导入设备',
    btnDel: '删除',
    btnEdit: '编辑',
    tableIpAddress: "IP地址",
    MACAddress: "MAC地址",
    firmwareVersion: "固件版本",
    NA: "N/A",
    tableDeviceName: '设备名称',
    tableStatus: '状态',
    tableVideoSwitch: '视频切换',
    tableAudio: '音视频广播',
    tablePowerControl: '电源控制',
    tableRS232: '串口控制',
    tableIR: '红外控制',
    tableRFIDCard: 'IC卡',
    tableControlPanel: '控制面板',
    tableOrganization: '组织',
    tableActions: '操作',
    dialogAddTitle: '添加设备',
    dialogEditTitle: '编辑设备',
    dialogBatchAddTitle: '批量添加设备',
    dialogBatchEditTitle: '批量编辑设备',
    btnCancel: '取消',
    Devices: '设备:',
    ProjectorCode: '串口码:',
    Group: '组织:',
    btnBatchAdd: '批量添加',
    delTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗？',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    content: '搜索',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    tableDel: '删除',
    tableEdit: '编辑',
    selectRoles: '选择角色',
    selectType: '选择类型',
    selectDevices: '请选择设备！',
    titleRealNameRq: '此项必填',
    titleRealNameNub: '50字以内',
    titlPassWordNub: '15字以内',
    error1900: '访问的参数为空',
    error2000: '超出最大可连接设备数',
    error2001: '导入的设备编码出错或暂未录入到系统中',
    error2002: '导入的设备名称重复',
    error2003: '导入的设备编码已经被使用',
    error2004: '导入的数据出错',
    error2005: '品牌和型号的名称，与系统中已有数据重复；请重新命令品牌或型号的名称。',
    error2008: '当前设备已关联其他组织',
    notDevicesName: '设备名称不能为空',
    notDevicesNO: '设备编码不能为空',
    dialogDevicesName: '设备名称:',
    dialogDevicesID: '设备ID:',
    dialogProjectorCode: '串口编码:',
    dialogGroup: '组织:',
    dialogSel: '请选择',
    errorOrgIdList: '组织机构不能为空！',
    errorDevicesName: '设备名称不能为空！',
    errorDevicesNo: '设备编码不能为空！',
    dialogTiltleDevices: '设备:',
    uploadSuccess: '上传成功',
    addSuccess: '添加成功',
    ChooseGroups: '选择组织',
    ChooseIcon: '选择图标',
    dialogDevicesTitle: '参数设置应用到以下设备',
    backDevice: '返回',
    bootSetting: '开机设置',
    nmpOpenSetting: '开机设置',
    npsOpenSetting: '开机设置',
    nmpPowerSettings: '开关机设置',
    npsPowerSettings: '开关机设置',
    nmpInterfaceSettings: '接⼝设置',
    npsInterfaceSettings: '接⼝设置',
    nmpDefaultChannel: '输入源设置',
    nmpCloseSetting: '关机设置',
    npsCloseSetting: '关机设置',
    startingUpMethod: '锁定面板:',
    SwipeToStart: '启用锁定（刷卡解锁）',
    ControlPanelToStart: '停用锁定（面板无使用限制）',
    Display: '显示设备',
    External: '外部电源',
    startWith: '开机同步启动:',
    nmpstartWith: '开机同步启动:',
    nmpcloseWith: '关机同步关闭:',
    RS232Tip: '当主电源关闭时，包括串口和最多4个CBX在内的总共5个串口接⼝将收到相应的关机指令码。',

    startPowerTip: '开机时联动所有CBX的电源接口设备打开。',
    startAirTip: '开机时通过设备/CBX红外统一开启所有绑定的空调。',
    startIrTip: '开机时通过设备/CBX红外发送联动指令（如幕布下降、投影仪开启）',
    startRSTip: '开机时通过设备/CBX的串口接口统一发送开机指令',
    CloseDisplayTip: '连接到DISPLAY接⼝的显示设备在NDP/NMP关机时会⾃动关闭。此设置由固件管理，⽆法在软件中更改。',
    CloseExternalTip: '"连接到EXTERNAL接⼝的设备在NDP/NMP关机时会⾃动关闭。此设置由固件管理，⽆法在软件中更改。',
    ClosePowerTip: '关机时联动所有CBX的电源接口设备关闭。',
    CloseAirTip: '关机时通过设备/CBX红外统一关闭所有绑定的空调。',
    CloseIrTip: '关机时通过设备/CBX红外发送联动指令（如幕布上升、投影仪关闭）。',
    CloseRSTip: '关机时通过设备/CBX的串口接口统一发送关机指令。',
    npsOpenRS232Tip: '当主电源开启时，NPS的2个串口接⼝将收到相应的开机指令码。',
    npsRS232Tip: '当主电源关闭时，NPS的2个串口接⼝将收到相应的关机指令码。',
    useCardTip: '刷卡解锁后，将⾃动启动设备主电源。',
    npsCardTip: '刷卡解锁后，将⾃动启动设备主电源。',
    PowerOutageHandling: '断电处理⽅式',
    PowerOutageHandTip: "如果您需要确保在意外断电时⽼师和学⽣能够进出教室，请选择 '断电开锁'。否则请选择 '断电关锁' 以限制出⼊。",
    acSetting: '空调控制设置',
    ChooseType: '选择类型',
    ChooseBrand: '选择品牌',
    ChooseModel: '选择型号',
    btnConnectingTest: '连接测试',
    LockSetting: '电子锁设置',
    ElectricLockType: '电子锁类型:',
    ElectricLockClosing: '电子锁关闭方式:',
    PowerUNLOCK: '断电开锁',
    PowerLOCK: '断电关锁',
    none: '无',
    oddParity: '奇校验',
    EvenParity: '偶校验',
    LastSetting: '上次关闭时选择的通道',
    manualSwitch: '手动开关',
    Auto: '自动关闭（间隔',
    projectorSetting: '设备选择与绑定',
    baudRate: '波特率',
    Parity: '奇偶校验',
    /*ON:'开机码',
    OFF:'关机码',*/
    ON: '电源ON',
    OFF: '电源OFF',
    Channel1: '通道一',
    Channel2: '通道二',
    PowerOffDelay: '关机延时断电',
    second: '秒',
    DefaultChannel: '主机默认输入源',
    HDMIA: 'HDMI out A:',
    HDMIB: 'HDMI out B:',
    HDMIC: 'HDMI out C:',
    btnSaveApply: '保存并应用到其他...',
    btnSave: '保存',
    btnCustomize: '自定义',
    ACIsPowerTitle: '请查看空调是否已开启？',
    ACIsPowerContent: '请先关闭空调再测试。如未成功开启，请确认空调品牌和型号是否正确。',
    btnNextModel: '否，测试下一型号',
    btnYes: '确定',
    errorConnecting: '连接测试失败',
    hot: '热门',
    '_POWERA': 'Display Power',
    '_POWERB': 'External Power',
    '_MAGNETICLOCK': '电子锁',
    '_HDMI1': 'HDMI in 1',
    '_HDMI2': 'HDMI in 2',
    '_HDMI3': 'HDMI in 3',
    '_HDMIA': 'HDMI out A',
    '_HDMIB': 'HDMI out B',
    '_HDMIC': 'HDMI out C',
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    '_AIR': '空调',
    '_USB1': 'USB 1',
    '_USB2': 'USB 2',
    '_USB3': 'USB 3',
    '_USBA': 'USB A',
    '_USBB': 'USB B',
    IRControl: '红外控制设置',
    acControlTitle: '空调控制:',
    acControlTitleNew: '空调控制',
    intelligentControlTitle: '智能遥控:',
    intelligentControlTitleNew: '智能遥控',
    btnACControlCode: '识别新空调控制码',
    btnAddRemoteControl: '添加新智能遥控码',
    ACControlCodeTitle: '识别新空调控制码',
    ACControlCodeseft1: "识别空调控制码",
    ACControlCodeseft2: "登记空调信息",
    btnStartIdentify: '开始识别',
    Identifysuccess: '识别成功!',
    BeingIdentify: '正在识别!',
    acBrand: '空调品牌',
    acModel: '空调型号',
    IdentifyFailureTitle: "识别失败",
    IdentifyFailureContent: '空调控制码识别失败，暂不支持此型号。建议使用智能遥控控制。',
    btnTryAgain: '再试一次',
    btnJump: '跳转',
    ACrideo: '空调',
    ortherRideo: '其他设备',
    btnBack: '返回',
    btnSortOut: '去整理',
    remoteControlSeft1: '选择设备类型',
    remoteControlSeft2: '开始学码',
    remoteControlSeft3: '设置信息',
    addRemoteControlError: '抱歉，可学习的智能遥控码条数已满。请先整理已有的智能遥控码。',
    btnPrevious: '上一步',
    btnNextStep: '下一步',
    remoteControlErrorTitle: '学码失败',
    remoteControlErrorContent1: '1.红外发射头未被遮挡',
    remoteControlErrorContent2: '2.接收器周围无强光干扰',
    remoteControlErrorContent3: '3.红外发射头安装无误',
    remoteControlErrorContent4: '4.遥控器工作正常',
    deviceItem1: '空调',
    deviceItem2: '投影仪',
    deviceItem3: '电视',
    deviceItem4: '电风扇',
    deviceItem5: '电灯',
    deviceItem6: '其它',
    deviceItem7: '液晶',
    deviceItem8: '录播',
    deviceItem9: 'PTZ摄像头',
    RS232protocol: '串口协议:',
    btnRemoteControl: '开始学码',
    BeingIdentify1: '正在学习!',
    Identifysuccess1: '学习成功!',
    controllerType1: '空调',
    controllerType2: '串口',
    controllerType3: '电视',
    controllerType4: '电风扇',
    controllerType5: '电灯',
    controllerType9: '其它',
    rqRemoteControlCode: '请输入智能遥控码名称',
    rqBrand: '请输入空调品牌',
    rqModel: '请输入空调型号',
    error2016: '智能遥控码名称重复，请重新输入',
    RS232Setting: '设备的串口设置',
    IR232Setting: '设备的IR设置',
    SystemError: '系统错误，请重试',
    conditionerCodeContent: '未识别到空调码，请重试',
    remoteControlCodeContent: '未识别到智能遥控码，请重试 ',
    btnRetry: '重试',
    Bindusers: "关联用户",
    tablebinduser: '关联用户',
    Refresh: '刷新',
    Binduserlable: "是否现在关联可控制设备的用户？",
    SaveApplySuccessfully: '保存并应用成功',
    DeviceType: '类型:',
    tableDeviceType: '类型',
    empty: '暂无数据',
    sendCommand: '延时发送命令',
    enable: '启用',
    disable: '停用',
    SYNCremoteControl: '启用开机联动智能遥控',
    analysisfailed: '识别失败，请再试一次！',
    // IRControl:'红外控制'
    CBX: {
      powerSupplyON: '电源ON',
      powerSupplyOFF: '电源OFF',
      powerVcrON: '开始录播',
      powerVcrOFF: '停止录播',
      lockScreenON: '锁屏ON',
      lockScreenOFF: '锁屏OFF',
      childLockON: '童锁ON',
      childLockOFF: '童锁OFF',
      energySavingON: '节能ON',
      energySaving: '节能',
      energySavingOFF: '节能OFF',
      signalSourceSwitchingON: 'OPS',
      signalSourceSwitchingOFF: 'Android',
      volumeAdjustment: '音量调节',
      brightAdjustment: '亮度调节',
      other: '其他...',
      volumeExample: '示例: 01 02 03 04 05 XX,请根据设备说明书上的提示依次输入',
      functionCode: '功能:',
      Name: '名称:',
      controlCode: '控制码:',
      brand: '品牌:',
      model: '型号:',
      errorBrandName: '品牌不能为空',
      errorModelName: '型号不能为空',
    }


  },
  projectorDevicesMge: {
    tipOne: '1.填写功能名称与控制码，控制码示例采用 HEX 格式。',
    tipTwo: '2.本界面仅做开关机串口命令配置，请至"设备管理/设备/操作/开关机设置"中进行功能启用。',
    tipFunctionOne: '1. 可从下拉列表选择常用功能，智能面板的串口控制界面将显示对应图标。',
    tipFunctionTwo: '2. "POWER ON"和"POWER OFF"命令用于设备开关机串口联动。本页仅配置控制码，联动功能需前往"设备管理 / 设备 / 操作 / 开关机设置"启用。',
    ListRS232functions: '串口控制功能列表',
    Customizefunctionlist: '自定义功能列表',
    btnAddProjectorCode: '添加串口码',
    btnDel: '删除',
    inputSeach: '搜索',
    btnEdit: '编辑',
    cancel: '清除',
    confirm: '确认',
    tableName: '名称',
    tableModel: '型号',
    tableBrand: '品牌',
    tablersType: '设备类型:',
    tablersTypeTable: '设备类型',
    tableActions: '操作',
    dialogAddTitle: '添加串口码',
    dialogEditTitle: '编辑串口码',
    brand: '品牌:',
    model: '型号:',
    codeName: '名称:',
    baudRate: '波特率:',
    parity: '奇偶校验:',
    powerOn: '开机码:',
    powerOff: '关机码:',
    pgrInput1: '通道一:',
    pgbInput2: '通道二',
    // video:'VIDEO:',
    // other:'OTHER:',
    // hdmi:'HDMI:',
    // standby:'STANDBY:',
    // powerSaving:'POWER SAVING:',
    // svideo:'SVIDEO:',
    delTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    content: '搜索',
    operate: '操作',
    tableDel: '删除',
    tableEdit: '编辑',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    selectTitle: '请选择串口！',
    selectCode: '请选择串口！',
    none: '无',
    oddParity: '奇校验',
    EvenParity: '偶校验',
  },
  roleMge: {
    role1: '普通用户',
    role101: '代理机构管理员',
    role102: '超级管理员',
    role4: '自定义角色',
    roleNew: '新角色',
    btnAddRole: '新建角色',
    RoleName: '角色名:',
    chooseUser: '选择用户：',
    titleLevel: '广播权限等级:',
    titleSettings: '权限设置:',
    btnSave: '保存',
    btnDelete: '删除',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    V3_0_OrganizationManage: '组织机构管理',
    V3_0_UserManage: '用户管理',
    V3_0_DeviceManage: '设备管理',
    V3_0_CloudSpaceManage: '云盘管理',
    V3_0_OrganizationManage_View: '查询',
    V3_0_OrganizationManage_Edit: '编辑',
    V3_0_UserManage_View: '查询',
    V3_0_UserManage_Edit: '编辑',
    V3_0_DeviceManage_AddDevice: '增加设备',
    V3_0_DeviceManage_Operating: '操作',
    V3_0_DeviceManage_Delete: '删除',
    V3_0_DeviceManage_Edit: '编辑',
    V3_0_CloudSpaceManage_PersonalManage: '个人云盘管理',
    V3_0_CloudSpaceManage_PublicManage: '公共云盘管理',
    V3_0_CloudSpaceManage_SpaceManage: '云盘空间管理',
    V3_0_CloudSpaceManage_PersonalManage_Operating: '可操作',
    V3_0_CloudSpaceManage_PersonalManage_View: '查询',
    V3_0_CloudSpaceManage_PublicManage_View: '查询',
    V3_0_CloudSpaceManage_PublicManage_Upload: '上传',
    V3_0_CloudSpaceManage_PublicManage_Download: '下载',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: '删除文件',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: '编辑文件夹',
    delTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗？',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    btnAdd: '添加角色',
    RoleName: '角色名:',
    ManageRange: '管理范围:',
    ChooseUser: '选择用户:',
    PermissionSettings: '权限设置:',
    BroadcastingPropertyLevel: '广播优先级别:',
    ChooseGroups: '选择组织',
    ChooseTheUser: '选择用户',
    deleleTitle: '新角色尚未保存，离开将删除该角色，确定离开吗？',
    Error1601: '不能使用超级管理员',
    Error1602: '获取角色失败',
    Error1603: '管理员才有权限使用此类功能',
    Error1604: '角色名称不能为空',
    Error1605: '机构不能为空',
    Error1606: '该角色已经存在',
    Error1607: '系统定义的角色，不允许修改',
    Error1608: '设置角色失败',
    Error1609: '系统普通用户角色，不允许修改',
    Error1610: '请使用终端管理员角色，进行相关操作',
    Error1611: '不具有相关角色权限',

  },
  authorityMge: {
    V3_0_OrganizationManage: '组织机构管理',
    V3_0_UserManage: '用户管理',
    V3_0_DeviceManage: '设备管理',
    V3_0_CloudSpaceManage: '云盘管理',
    V3_0_OrganizationManage_View: '查询',
    V3_0_OrganizationManage_Edit: '编辑',
    V3_0_UserManage_View: '查询',
    V3_0_UserManage_Edit: '编辑',
    V3_0_DeviceManage_AddDevice: '增加设备',
    V3_0_DeviceManage_Operating: '操作',
    V3_0_DeviceManage_Delete: '删除',
    V3_0_DeviceManage_Edit: '编辑',
    V3_0_DeviceManage_RepairLog: '报修日志',
    V3_0_CloudSpaceManage_PersonalManage: '个人云盘管理',
    V3_0_CloudSpaceManage_PublicManage: '公共云盘管理',
    V3_0_CloudSpaceManage_SpaceManage: '云盘空间管理',
    V3_0_CloudSpaceManage_PersonalManage_Operating: '可操作',
    V3_0_CloudSpaceManage_PersonalManage_View: '查询',
    V3_0_CloudSpaceManage_PublicManage_View: '查询',
    V3_0_CloudSpaceManage_PublicManage_Upload: '上传',
    V3_0_CloudSpaceManage_PublicManage_Download: '下载',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: '删除',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: '编辑',
    delTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    content: '搜索',
    operate: '操作',
    tableDel: '删除',
    tableEdit: '编辑',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    selectTitle: '请选择串口！'
  },
  workstationMge: {
    priorChoice: '优先选择:',
    SpeedPriority: '广播速度优先',
    SyncPriority: '广播同步优先',
    SpeedPriorityTip: '当广播指令发出后，接收终端以较短的缓冲时间执行播放任务，一般缓冲时间在3-5秒。媒体服务器部署在局域网内的情况下，建议选择速度优先。',
    SyncPriorityTip: '当广播指令发出后，所有接收终端将同步播放广播内容，一般缓冲时间在8-12秒。',
    btnAddMedia: '添加媒体工作站',
    btnBack: '返回',
    tableMediaLibId: '媒体工作站ID',
    tableMediaLibName: '媒体工作站名',
    tableState: '联网状态',
    tableBindingUsers: '绑定用户',
    tableLiveAddress: '直播地址',
    tableAddress: '广播地址',
    tableOperate: '操作',
    tableDel: '删除',
    tableEdit: '编辑',
    titleMediaStation: '广播地址:',
    titleLiveStation: '直播地址:',
    radioPublic: '公网',
    radioPrivate: '内网',
    btnSave: '保存',
    titleUsers: '用户',
    titleCanBe: '可绑用户数',
    titleHaveBeen: '已绑用户数',
    titleMore: '需要添加更多?',
    btnAdd: '添加',
    content: '搜索',
    tableName: '姓名',
    tableUserName: '用户名',
    operate: '操作',
    affiliatedOrganization: '组织',
    dialogTitle: '添加新媒体工作站',
    dialogTitleEdit: '修改新媒体工作站',
    dialogItemName: '名称:',
    dialogItemId: 'ID:',
    dialogItemIp: '广播地址:',
    titleSelectUsers: '选择用户',
    selectMedia: '请选择媒体列表',
    delTitle: '确定删除?',
    delMediaLibTitle: '确定删除?',
    delTitleContent: '所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗？',
    delTitleMediaLibContent: '删除该内容将导致相关数据都被清除，且无法撤回。',
    delCancelButton: '取消',
    delConfirmButton: '确认',
    selectDevices: '请选择设备',
    selectUser: '请选择用户',
    addUser: '添加用户',
    editUser: '编辑用户',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    error2500: '超出最大当前工作站最大可连接设备数',
    DeviceName: '设备名称',
    AssociatedUserManagement: '关联用户管理',
    btnDel: '删除',
    errorMsgId: "找不到该设备ID",
    LiveStreaming: '直播地址:',
    NoFoundMediaId: '获取不到媒体工作站的ID',
    AlreadyConnectedOrg: '媒体工作站已关联其他组织',
    AlreadyBoundMedia: '已有绑定媒体工作站，无法继续绑定新的媒体工作站',
    DeleteSecondaryConfirmation: '删除媒体工作站后数据无法恢复，请二次确认。'
  },
  cloudDiskMge: {
    totalStorage: '总空间',
    GetMore: '获取更多',
    StorageSpace: '存储空间',
    Adjustment: '空间调整',
    moreSpace: '获取更多存储空间',
    PublicStorage: '公共盘',
    IndividualStorage: '个人盘',
    PublicStorageUsed: '已用公共盘',
    PublicStorageLasted: '剩余公共盘',
    IndividualStorageUsed: '已用个人盘',
    IndividualStorageLasted: '剩余个人盘',
    storageSpace: '存储空间调整',
    tableUserName: '用户名',
    tableUsedSpace: '已用空间',
    tableAvailableSpace: '可用空间',
    tableActiveTime: '上次使用时间',
    tableOperate: '操作',
    cleanup: '提醒用户清理',
    IndividualStorageSpaceAdjustment: '个人存储空间调整',
    titleTotal: '存储空间总大小',
    PublicDisk: '公共盘',
    IndividualDisk: '个人盘',
    PerUser: '/人',
    UsersInTotal: '总用户数',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    addSuccess: '添加成功！',
    addError: '添加失败!',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    delSuccess: '删除成功！',
    delError: '删除失败!',
    error3000: '已超过云盘总大小，操作失败。',
    error3003: '未绑定媒体工作站，此操作失败。',
    IndividualStorage: '个人盘',
    NoteToCleanup: '通知清理',
    updatePersonalSuccess: '你的云盘空间将满，请及时清理',
    updatePersonalSuccess1: '修改保存成功',
    storageUsage: '个人盘使用情况',
    bindIndividualstorage: '可开通个人盘总用户数',
    UserIndividualstorage: '已开通个人盘用户数',
    Notificationsuccessfully: '已发送通知',
    Notificationfailed: '通知发送失败',
    tableName: '姓名',
    userID: '用户ID',
  },
  dashboard: {
    exportPdf: '导出PDF',
    'or': '-',
    // 'startTime':'开始时间',
    // 'endTime':'结束时间',
    'warrantyCompletionRate': '报修完成率',
    'frequencyOfEachModule': '各模块维修频率',
    'repairHandling': '报修处理情况',
    'sourceSwitchInput': '输入源切换',
    'micVol': '麦克风音量',
    'volumeSpeaker': '音箱音量',
    'airAonditioner': '空调',
    'Curtain': '幕布',
    'remoteControlIntelligent': '智能遥控',
    'RS232Control': '串口控制',
    'lockElectronic': '电子锁',
    'Repairreportcompleted': '已完成报修',
    'Totalnumberofrepairsreported': '总报修数',
    'Warrantycompletionrate': '报修完成率',
    'startDate': '开始日期',
    'endDate': '结束日期',
    'year': '年',
    'month': '月',
    'day': '日',
    dayTian: '日',
    'placeholderDate': '选择日期',
    'placeholderDateTime': '选择日期时间',
    'devicesNub': '设备数',
    'userNub': '用户数',
    'powerNub': '用电量(KW/H)',
    'storageUsed': '云盘用量(%)',
    'userLoginDevice': '用户活跃时间',
    'devicePowerConsumption': '总设备用电量',
    'externalDeviceUsageTime': '外接设备使用时长',
    'equipmentRunningTime': '终端设备运行时长',
    'cloudStorageSpace': '存储空间',
    'powerConsumptionPort': '设备使用次数',
    'mostPopularFile': '常用文档',
    'commonFunctions': '常用功能',
    'commonlyUsed': '常用广播方式',
    'fileName': '文件名',
    'usageCount': '使用次数',
    // 'electricityConsumption':'用电量标识',
    'electricityConsumption': '用电量',
    'publicStorageUsed': '公共盘用量',
    'publicStorageLasted': '公共盘剩余空间',
    'individualStorageUsed': ' 个人盘用量',
    'individualStorageLasted': '个人盘剩余空间',
    'total': '总量',
    'notification': '文字通知',
    'audioBroadcast': '音频广播',
    'videoBroadcast': '视频广播',
    'ac': '空调调节',
    'hDMISwitch': '视频切换',
    'powerControl': '电源控制',
    'powercontrol': '电源控制',
    'Lock': '磁控锁开关',
    'volumeAdjust': '音量调节',
    'projectionScreen': '幕布升降',
//     音量调节(Volume Adjust)，
// 磁控锁开关（Lock），
// 幕布升降（Projection Screen）
    'today': '今天',
    'yesterday': '昨天',
    'thisWeek': '本周',
    'lastWeek': '上周',
    'lastMonth': '上月',
    'thisMonth': '本月',
    'times': '次数',
    'usage': '功能使用次数',
    'eachrTitle': '分钟',
    total: '总次数',
    NMPSystemissue: 'NMP系统问题',
    displayPower: 'NMP外接设备问题',
    externalPower: 'MBX系统问题',
    screen: 'MBX外接设备问题',
    TotalRepairs: '全部报修数',
    Repaired: '已完成保修',
    Unrepaired: '未完成报修',
    day: '天',
    Minutes: '分钟',
    powerConsumption: '分钟',
    Date: "日期",
    kw: '千瓦',
    month1: '周一',
    month2: '周二',
    month3: '周三',
    month4: '周四',
    month5: '周五',
    month6: '周六',
    month7: '周日',
    enmonth1: 'Jan',
    enmonth2: 'Feb',
    enmonth3: 'Mar',
    enmonth4: 'Apr',
    enmonth5: 'May',
    enmonth6: 'Jun',
    enmonth7: 'Jul',
    enmonth8: 'Aug',
    enmonth9: 'Sep',
    enmonth10: 'Oct',
    enmonth11: 'Nov',
    enmonth12: 'Dec',
    noData: '暂无数据'
  },
  input: {
    fivedigits: '请输入5位内的正整数',
    titlUserNameField: '用戶名必填',
    thisField: '此项为必填项.',
    ChooseGroup: '请选择组织',
    placeholder: '请选择',
    placeholder_type: '选择设备控制类型',
    titlRealNameField: '姓名为必填项',
    thisPasswordField: '密码为必填项',
    titlPassWordNub: '密码需在6~30个字符之间',
    Post: '只能输入数字',
    passwordNoChinese: '此输入框不能填入汉字',
  },
  transfer: {
    all: '全选',
    Choose: '选择',
    Selected: '已选',
    Subordinate: '下级'
  },
  setting: {
    limitPngGif: '仅支持 PNG / GIF 格式',
    limit3M: '图片大小不能超过 3MB',
    setting_door_Wallpaper_text: '推荐图片尺寸：1280x800，PNG 或 GIF 格式',
    reduction: '还原',
    limitJpg: '上传头像图片只能是PNG格式!',
    limit2M: '上传头像图片大小不能超过 2MB!',
    choseFile: '选择文件',
    textOne: '1. Logo大小推荐：117*40（图片格式为PNG）',
    textTwo: '2.上传成功后，可点击智能面板Logo位置处进行更新。（智能面板需连接互联网）',
    customizeLogo: '自定义Logo',
    addSuccess: '设置成功！',
    settingIp: '⽂件存储IP设置',
    ServerIP: 'IP地址:',
    ServerPort: '端口:',
    btnSave: '保存',
    TimeZoneSetting: '时区设置',
    CurrentTime: '当前时间:',
    CurrentTimeZone: '当前时区:',
    httpsSetting: '⽂件存储地址设置:',
    utcName: '格林威治时间 UTC/GMT',
    utc0: '格林威治时间、英国、里斯本、托尔斯港、伦敦、都柏林、爱丁堡',
    utc0_5: '',
    utc1: '欧洲中部、西非、中非西部、德国、爱尔兰、法国、阿姆斯特丹、意大利、柏林、罗马、西班牙、布拉格、贝尔格莱德、布鲁塞尔、巴黎、马德里、 突尼斯、加蓬、摩洛哥',
    utc1_5: '',
    utc2: '非洲东部、俄罗斯、巴格达、科威特、莫斯科、圣彼得堡',
    utc2_5: '',
    utc3: '佛得角、亚速尔群岛',
    utc3_5: '伊朗',
    utc4: '阿布扎比、第比利斯、迪拜、毛里求斯、路易港',
    utc4_5: '阿富汗',
    utc5: '巴基斯坦、土库曼斯坦、马尔代夫、乌兹别克斯坦、亚美比亚、塔吉克斯坦印度、孟买、新德里、班加罗尔、加尔各答',
    utc5_5: '印度标准时间(印度),斯里兰卡',
    utc6: '新西伯利亚、吉尔吉斯斯坦、孟加拉国国、不丹',
    utc6_5: '澳大利亚科克斯群岛,缅甸',
    utc7: '泰国、曼谷、河内、雅加达',
    utc7_5: '',
    utc8: '中国、马来西亚、菲律宾、新加坡、中国台湾、中国澳门、中国香港',
    utc8_5: '',
    utc9: '日本、韩国、东京、首尔、札幌、大阪、东帝汶',
    utc9_5: '澳大利亚中部标准时间(北方地区,南澳大利亚州,新南威尔士州断山)',
    utc10: '澳大利亚、海参崴、关岛、堪培拉、墨尔本、悉尼、巴布亚新几内亚',
    utc10_5: '澳大利亚新南威尔士州豪爵士岛',
    utc11: '所罗门群岛、库页岛',
    utc11_5: '澳大利亚诺福克岛',
    utc12: '新西兰、奥克兰、惠灵顿、斐济、新西兰、瑙鲁',
    utc12_5: '',
    utc13: '佛得角、亚速尔群岛',
    utc13_5: '',
    utc14: '南乔治亚岛、费尔南多-迪诺罗尼亚岛',
    utc14_5: '',
    utc15: '巴西、圣地亚哥、萨尔瓦多、巴西利亚、乌拉圭、阿根廷、苏里南',
    utc15_5: '纽芬兰标准时间(加拿大纽芬兰-拉布拉多州纽芬兰岛和拉布拉多半岛南端部)',
    utc16: '委内瑞拉、玻利维亚、巴拉圭、智利',
    utc16_5: '委内瑞拉',
    utc17: '东部时间(美国和加拿大)、哥伦比亚、多伦多、厄瓜多尔、秘鲁、古巴、纽约、汉密尔顿、圣地亚哥',
    utc17_5: '',
    utc18: '美国和加拿大中部时间、墨西哥城、蒙特雷、芝加哥、休斯顿、新奥尔良、孟菲斯',
    utc18_5: '',
    utc19: '山地时间、亚利桑那、马萨特兰、凤凰城、盐湖城、丹佛、埃德蒙顿',
    utc19_5: '',
    utc20: '太平洋时间、洛杉矶、旧金山、温哥华、西雅图、拉斯维加斯',
    utc20_5: '',
    utc21: '阿拉斯加',
    utc21_5: '法属波利尼西亚马克萨斯群岛',
    utc22: '夏威夷',
    utc22_5: '',
    utc23: '萨摩亚、纽埃岛',
    utc23_5: '',
    utc24: '',
  },
  repairLog: {
    // tabAll:'ALL',
    // tabDelivered:'Delivered',
    // tabInProcess:'In Process',
    // tabCompleted:'Completed',
    DeviceName: '设备名:',
    Time: '时间:',
    startDate: '开始时间',
    endedDate: '结束时间',
    or: '-',
    Problem: '问题模块:',
    btnSearch: '搜索',
    tableNO: 'NO',
    tableDeviceName: '报修设备名',
    tableGroup: '组织',
    tableStatus: '状态',
    tableDeliveredTime: '提交时间',
    tableSubmitter: '提交人',
    tableUpdatingTime: '更新时间',
    tableProblem: '问题模块',
    tableAdmin: '负责人',
    tableAdminReply: '回复',
    tableAttachment: '附件',
    state0: '待解决',
    state1: '处理中',
    state2: '已完成',
    Problem100: '全部',
    Problem0: '系统问题',
    Problem1: '外接设备问题',
    ProblemType: '',
    ProblemType0: '电源控制',
    ProblemType1: '视频切换',
    ProblemType2: '麦克风音量',
    ProblemType3: '音箱音量',
    ProblemType4: '空调',
    ProblemType5: '幕布',
    ProblemType6: '电子锁',
    ProblemType7: '广播',
    ProblemType8: '红外控制',
    ProblemType9: '串口控制',
    dialogDeviceName: '设备名:',
    dialogDeviceID: '设备ID',
    dialogGroup: '组织:',
    dialogStatus: '选择状态:',
    dialogProblem: '问题模块:',
    dialogNotes: '问题描述:',
    DeliveredTime: '提交时间:',
    UpdatingTime: '更新时间',
    dialogSubmitter: '提交人:',
    ITAdmin: '负责人:',
    AdminReply: '回复:',
    Note: '问题描述',
    dialogRepairation: '报修日志',
    dialogInProcess: '处理中',
    dialogCompleted: '已完成',
    editSuccess: '编辑成功！',
    editError: '编辑失败!',
    problemRequired: '请选择问题模块',
    detailRequired: '请描述问题详情',
    statusRequired: '请选择问题状态',
    btnCancel: '取消',
    Detail: '问题详情',
    controlPanel: '控制面板',
    DeviceType: '类型:',
    dialogDeliveredTime: '提交时间:',
    Submitter: '提交人:',
  },
  remoteControl: {
    QuickActionName: '智能遥控名称',
    DeviceType: '类型',
    Description: '描述:',
    tableDescription: '描述',
    editRemoteControl: '编辑智能遥控码',
    QuickActionNameInput: '智能遥控码名称：',
    DescriptionInput: '描述:',
    save: '保存',
    Brand: '品牌',
    Model: '型号',
    EditACControlCode: '修改空调控制码',
    acBrand: '空调品牌',
    acModel: '空调型号'
  },
  card: {
    btnAddCard: '新建卡',
    btnBatchAddCard: '批量新建卡',
    tableCard: '卡号',
    tableState: '状态',
    tableUser: '关联用户',
    tableID: '登录名',
    tableType: '卡类型',
    tableFfective: '有效期',
    dialogCard: '卡号：',
    dialogState: '状态：',
    dialogUser: '关联用户：',
    dialogID: '登录名：',
    dialogType: '卡类型：',
    dialogFfective: '有效期：',
    dialogRemarks: '备注：',
    dialogAddTitle: '新建卡',
    dialogEidtTitle: '修改卡',
    code2201: '卡的有效期格式设置有误',
    code2202: '此卡已经绑定',
    code2203: '此用户已经绑定',
    code2204: '此卡未绑定',
    mastCard: '总控卡',
    regularCard: '普通卡',
    permanent: '永久',
    coxPermanent: '永久',
    coxTime: '一定时间内',
    tableDeviceName: '设备名称',
    tableDeviceID: '设备ID',
    tableOperating: '操作',
    tableOperatingTime: '操作时间',
    tableCardID: '卡号',
    tableCardType: '卡类型',
    tabluserName: '用户名',
    tabluserId: '用户ID',
    unlockPanel: '解锁面板',
    unlock: '开锁',
    conAll: '全部',
    btnEnable: '启用',
    btnDisable: '禁用',
    enableSuccess: '启用成功',
    stopSuccess: '禁用成功',
    enableError: '启用失败',
    stopError: '禁用失败',
    titlCardField: '卡号不能为空',
    titlCardFieldFormat: '卡号只能输入字母和数字',
    batchCard: '批量卡号:',
    dialogBachAddTitle: '批量新建卡',
    pleaseTryAgain1: '卡号错误（编号：',
    pleaseTryAgain2: '），请重试',
  },
  privacy: {
    PrivacyPolicy: '绑定微软组织隐私协议',
    Byusing: '尊敬的用户：',
    whatinformation: '在您授权Q-NEX访问微软数据前，请仔细阅读本协议。本协议是对《Q-NEX隐私政策》的补充，明确说明同步功能所需的权限、数据用途及保护措施。勾选“同意”即表示您已阅读并接受本协议全部内容。',
    EffectiveDate: '生效日期：2025年8月4日',
    title1: '所需权限及收集的数据',
    title1Respects1: 'Q-NEX需通过微软授权获取以下权限，以实现会议门牌与微软日历的同步功能：',
    title1Respects2: '委托权限',
    Respects2formation: '这些权限允许Q-NEX在您登录并同意后访问您的微软账户数据：',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: '权限名称：拥有用户日历的完全访问权限',
    Respects2formation4: '权限说明：允许应用创建、读取、更新和删除用户日历中的事件',
    Respects2formation5: '用途：将用户个人日历中的会议同步至Qnex系统',
    Respects2formation6: 'offline_access',
    Respects2formation7: '权限名称：保持对您授予其访问权限的数据的访问权限',
    Respects2formation8: '权限说明：允许应用在您未使用时仍能访问已授权的数据',
    Respects2formation9: '用途：确保即使用户未登录时，会议信息仍能保持同步',
    Respects2formation10: 'Openid',
    Respects2formation11: '权限名称：以您的身份登录',
    Respects2formation12: '权限说明：允许您使用工作或学校账户登录应用，并允许应用读取您的基本资料',
    Respects2formation13: '用途：验证用户身份确保数据安全，关联用户个人资料和会议数据',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: '权限名称：读取所有公司场所',
    Respects2formation16: '权限说明：允许应用代表您读取公司的场所（会议室和会议室列表）',
    Respects2formation17: '用途：获取公司会议室资源列表，同步会议室预定状态',

    tp1: '应用权限（需管理员同意）',
    tp2: '这些权限允许Q-NEX在后台自动同步数据，无需每次手动授权：',
    tp3: 'Calendars.ReadWrite',
    tp4: '权限名称：读取和写入所有邮箱中的日历',
    tp5: '权限说明：允许应用在无需登录用户的情况下创建、读取、更新和删除所有日历中的事件',
    tp6: '用途：同步公司所有会议室资源邮箱的日程',
    tp7: 'Directory.Read.All',
    tp8: '权限名称：读取目录数据',
    tp9: '权限说明：允许应用在无需登录用户的情况下读取组织目录中的数据，例如用户、群组和应用',
    tp10: '用途：验证会议室资源邮箱的有效性，获取组织架构信息',
    tp11: 'User.Read.All',
    tp12: '权限名称：阅读所有用户的完整个人资料',
    tp13: '权限说明：允许应用在没有登录用户的情况下读取用户个人资料',
    tp14: '用途：识别会议参与者的身份',
    tp15: 'Place.Read.All',
    tp16: '权限名称：读取所有公司地点',
    tp17: '权限说明：允许应用读取公司地点（会议室和房间列表）以用于日历事件和其他应用程序，无需登录用户',
    tp18: '用途：获取完整的会议室资源列表，同步会议室使用状态',

    title2: '数据用途',
    title2Respects1: '将微软日历中的会议日程同步至Q-NEX系统，并在会议门牌上实时显示',
    title2Respects2: '自动更新会议室资源状态，避免日程冲突',
    title2Respects3: '提供统一的会议管理体验',

    title3: '数据存储与保护',
    title3Respects1: '所有同步数据将加密存储于Q-NEX服务器，仅用于实现本功能',
    title3Respects2: 'Q-NEX不会将您的日历数据共享给第三方，除非为遵守法律要求或保护系统安全',
    title3Respects3: '数据跨境传输时，我们将通过合同条款或认证机制确保符合适用法律',

    title4: '您的权利',
    title4Respects1: '随时通过Q-NEX后台解除微软账户绑定，终止数据同步',

    title5: '注意事项',
    title5Respects1: '请确保您拥有所绑定微软账户的管理权限或合法授权',
    title5Respects2: '解除绑定后，Q-NEX将停止同步新数据，但历史数据可能按合规要求保留一定期限',

    contactInformation: '联系信息',
    contactInformationContent: '有疑问，请联系：info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js